const preventChildrenClickPropagation = (onClick: () => void) => {
  const handleClick = (e: React.MouseEvent) => {
    const target = e.target as HTMLElement;
    const isClickable = target.closest(
      'button, [role="button"], a, input, select, textarea',
    );

    if (!isClickable) {
      onClick();
    }
  };

  return handleClick;
};

export default preventChildrenClickPropagation;
